import React from 'react';
import {connectToStore} from './Provider';
import Reveal from './Reveal';
import createTaxonomyLink from '../utils/createTaxonomyLink';
import {Link} from 'gatsby';

const VideoModalPromo = ({
	title,
	subtitle,
	description,
	posterImage,
	videoModal,
	cta,
	openVideoModal
}) => {
	let ctaButton;
	let posterButton;
	const onClickVideo = () => openVideoModal(cta.videoId);

	if (cta._type === 'videoModalLink') {
		ctaButton = (
			<button
				title={cta.title}
				onClick={onClickVideo}
				name="video"
				className="button--primary-black full-width">
				{cta.title}
			</button>
		);

		posterButton = (
			<button
				title="Play"
				onClick={onClickVideo}
				className="full-width pr video__poster bg--black"
				name="play">
				<div className="reveal__fade">
					<picture
						className="full-width">
						<source
							srcSet={`${posterImage}?w=1200&auto=format`}
							media="(min-width: 600px)"
						/>
						<img
							className="full-width"
							alt={title}
							src={`${posterImage}?w=800&auto=format`}
						/>
					</picture>
				</div>
				<span className="db video__poster__play" />
				<img
					className="db video__poster__icon"
					alt="play"
					src="/images/icon-play.svg"
				/>
			</button>
		);
	} else if (cta._type === 'link') {
		if (cta.url[0] === '/') {
			ctaButton = (
				<Link
					title={cta.title}
					to={cta.url}
					className="button--primary-black full-width">
					{cta.title}
				</Link>
			);
	
			posterButton = (
				<Link
					to={cta.url}
					className="full-width pr video__poster bg--black"
					title={cta.title}>
					<div className="reveal__fade">
						<picture
							className="full-width">
							<source
								srcSet={`${posterImage}?w=1200&auto=format`}
								media="(min-width: 600px)"
							/>
							<img
								className="full-width"
								alt={title}
								src={`${posterImage}?w=800&auto=format`}
							/>
						</picture>
					</div>
					<span className="db video__poster__play" />
					<img
						className="db video__poster__icon"
						alt="play"
						src="/images/icon-play.svg"
					/>
				</Link>
			);
		} else {
			ctaButton = (
				<a
					title={cta.title}
					href={cta.url}
					className="button--primary-black full-width">
					{cta.title}
				</a>
			);
	
			posterButton = (
				<a
					href={cta.url}
					className="full-width pr video__poster bg--black"
					title={cta.title}>
					<div className="reveal__fade">
						<picture
							className="full-width">
							<source
								srcSet={`${posterImage}?w=1200&auto=format`}
								media="(min-width: 600px)"
							/>
							<img
								className="full-width"
								alt={title}
								src={`${posterImage}?w=800&auto=format`}
							/>
						</picture>
					</div>
					<span className="db video__poster__play" />
					<img
						className="db video__poster__icon"
						alt="play"
						src="/images/icon-play.svg"
					/>
				</a>
			);
		}
	} else if (cta._type === 'taxonomyLink') {
		ctaButton = (
			<Link
				title={cta.title}
				to={createTaxonomyLink(cta.taxonomies)}
				className="button--primary-black full-width">
				{cta.title}
			</Link>
		);

		posterButton = (
			<Link
				to={createTaxonomyLink(cta.taxonomies)}
				className="full-width pr video__poster bg--black"
				title={cta.title}>
				<div className="reveal__fade">
					<picture
						className="full-width">
						<source
							srcSet={`${posterImage}?w=1200&auto=format`}
							media="(min-width: 600px)"
						/>
						<img
							className="full-width"
							alt={title}
							src={`${posterImage}?w=800&auto=format`}
						/>
					</picture>
				</div>
				<span className="db video__poster__play" />
				<img
					className="db video__poster__icon"
					alt="play"
					src="/images/icon-play.svg"
				/>
			</Link>
		);
	}

	return (
		<div className="mt8 mb8 mt10--md mb10--md">
			<Reveal>
				<div className="pt2--md pb2--md">
					<div className="grid-container contained">
						<div className="row align--middle">
							<div className="col c6--md mb2 mb0--md">
								{posterButton}
							</div>
							<div className="col c6--md">
								<div className="pl8--lg">
									<h2 className="domaine--large mb1">{title}</h2>
									<p className="sans--medium mb2 pr10--lg">{subtitle}</p>
									<p className="color--gray-text video-promo__description">{description}</p>
									<div className="hide--md mt3">
										{ctaButton}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Reveal>
		</div>
	);
};

const mapStateToProps = () => ({});

const mapStoreToProps = ({
	openVideoModal,
}) => ({
	openVideoModal,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(VideoModalPromo);